module.exports = __webpack_public_path__ + "img/home page.79746958.png";